<template>
  <div class="home">
    <div class="lampCont">
      <img class="lamps" src="../assets/lamps.svg" alt />
    </div>
    <div class="heading">
      <h1>Sahani Decors - Interior Works</h1>
      <p>
        making
        <strong>your space</strong> more
        <strong>beautiful</strong>, more
        <strong>usable</strong>
      </p>
      <p class="since">experts in field since 1998</p>
    </div>
    <div class="showstuff">
      <HowProcess />
      <div class="together">
        <Showcase id="projects" class="showcase" />
        <img class="shelfs" src="../assets/shelfs.svg" alt />
      </div>
    </div>
    <MyFooter :footer-image="footerImage" />
  </div>
</template>

<script>
import Showcase from "@/components/Showcase";
import MyFooter from "@/components/MyFooter";
import HowProcess from "@/components/HowProcess";
export default {
  name: "Home",
  data: function() {
    return {
      footerImage: require("../assets/sofa.svg")
    };
  },
  components: {
    HowProcess,
    MyFooter,
    Showcase
  }
};
</script>

<style scoped lang="scss">
.home {
  overflow: hidden;
  position: relative;
  z-index: 2;

  div.lampCont {
    border-top: 1px solid $darkPrimary;
    width: 30vw;
    transform: translateX(0.5rem);
    @include mediumScreen {
      width: 20vw;
      margin-bottom: 2rem;
      transform: translateX(7.5vw);
    }
    @include bigScreen {
      width: 15vw;
    }
  }

  .heading {
    font-weight: 100;
    margin: 2rem 0.5rem;
    text-align: center;

    @include mediumScreen {
      font-size: 1.3rem;
      text-align: right;
      width: 60vw;
      margin: -2rem 20vw 2rem auto;
    }

    @include bigScreen {
      font-size: 1.7rem;
    }

    p {
      font-weight: bold;
      font-size: 1.7rem;

      @include mediumScreen {
        font-size: 2rem;
      }

      strong {
        color: $accentPrimary;
      }
    }

    .since {
      left: 0;
      font-size: 0.9rem;

      &::before {
        align-self: center;
        padding: 1rem;
        margin: 0 0.5rem;
        position: relative;
        width: 3rem;
        content: "";
        background: linear-gradient($accentPrimary, $accentSecondary) no-repeat
          center / 100% 1px;
      }
    }
  }

  .showstuff {
    position: relative;
    margin: 0 0.5rem;
    @include mediumScreen {
      display: flex;
      /* flex-direction: row-reverse; */
      margin: auto;
      margin-left: 10vw;
      justify-content: space-between;
    }
    @include bigScreen {
      margin-left: 10vw;
    }

    .together {
      display: flex;
      justify-content: center;
      margin: 2rem 0;
      text-align: center;
      @include mediumScreen {
        text-align: left;
        text-align: start;
      }

      .showcase {
        min-width: 15rem;
      }

      img.shelfs {
        margin-top: -5%;
        min-width: 15rem;
        max-width: 25vw;
        position: relative;
        z-index: -2;
        display: none;

        @include mediumScreen {
          width: 25vw;
          display: inline-block;
        }
      }
    }
  }
}
</style>
